import React from 'react';
import { useAuth } from '../context/AuthContext';
import Certificate from '../components/Certificate';
import { FaAward, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Certificates = () => {
    const { user, enrolledCourses } = useAuth();
    const navigate = useNavigate();

    const completedCourses = enrolledCourses.filter(course => course.progress === 100);

    return (
        <div className="container-fluid py-5 px-lg-5" style={{ background: '#f8f9fa', minHeight: '100vh' }}>
            <div className="d-flex align-items-center mb-4">
                <button className="btn btn-light me-3 border" onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Back to Dashboard
                </button>
                <h1 className="display-6 fw-bold mb-0">My Certificates</h1>
            </div>
            
            {completedCourses.length > 0 ? (
                <div className="row">
                    {completedCourses.map(course => (
                        <div key={course.id} className="col-md-6 mb-4">
                           <Certificate
                                student={user}
                                course={course}
                                issueDate={new Date(course.completedAt || Date.now()).toLocaleDateString()}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center text-muted py-5 bg-white rounded-3 shadow-sm">
                    <FaAward size={50} className="mb-3" />
                    <h4>No Certificates Yet</h4>
                    <p>Complete a course to earn your first certificate!</p>
                    <button className="btn btn-primary mt-3" onClick={() => navigate('/courses')}>
                        Explore Courses
                    </button>
                </div>
            )}
        </div>
    );
};

export default Certificates;
